export function downloadBlob(blob: Blob, filename: string): void {
  console.log("[FileUtils] downloadBlob 开始");
  console.log("[FileUtils] Blob 大小:", blob.size);
  console.log("[FileUtils] Blob 类型:", blob.type);
  console.log("[FileUtils] 文件名:", filename);

  try {
    const url = URL.createObjectURL(blob);
    console.log("[FileUtils] Object URL 创建成功:", url);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);

    console.log("[FileUtils] 开始触发下载");
    link.click();
    console.log("[FileUtils] 下载触发成功");

    document.body.removeChild(link);

    console.log("[FileUtils] 延迟撤销 URL");
    setTimeout(() => {
      URL.revokeObjectURL(url);
      console.log("[FileUtils] URL 已撤销");
    }, 100);

    console.log("[FileUtils] downloadBlob 完成");
  } catch (error) {
    console.error("[FileUtils] downloadBlob 失败:", error);
    throw error;
  }
}

export function readFileAsText(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = ((e: ProgressEvent<FileReader>): void => {
      const target = e.target;
      if (target && target.result !== null) {
        resolve(target.result as string);
      } else {
        reject(new Error("Failed to read file"));
      }
    }) as (event: ProgressEvent<FileReader>) => void;
    reader.onerror = ((): void => {
      reject(new Error("Failed to read file"));
    }) as () => void;
    reader.readAsText(file);
  });
}

export function chunkFile(file: File, chunkSize: number): Blob[] {
  const chunks: Blob[] = [];
  let offset = 0;

  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunkSize);
    chunks.push(chunk);
    offset += chunkSize;
  }

  return chunks;
}
